<template>
  <div class="audience_usage" :class="[{'thirty_days_expired': thirtyDaysExpired }, {'unredirectable': unRedirectable }]" @click="$emit('click')">
    <div class="audience_usage-header">
      <span class="audience_usage-title">
        {{ title }}
      </span>
      <svg
        v-if="!unRedirectable"
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M7 17L17 7" />
        <path d="M7 7h10v10" />
      </svg>
    </div>
    <div class="audience_usage-content">
      <spinner
        v-if="isLoading && !error"
        width="20"
        height="20"
      />
      <div v-else-if="!isLoading && error" class="has_an_error">
        <svg-icon name="reload" size="medium" />
      </div>
      <div
        :title="isTotal ? `${counter} / ${total}` : counter"
        v-else
      >
        <span
          class="nb_active_audience"
          :class="{ 'active' : isTotal }"
        >{{ counter }}</span>
        <template v-if="isTotal">
          / {{ total }}
        </template>
        <span
          class="thirty-days"
          v-if="title.includes('Expiring')"
        >
          {{ thirtyDays }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'AccountUsagesCard',
    props: {
        title: {
            type: String,
            default: ''
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        allowed: {
            type: Boolean,
        },
        counter: {
            type: [String, Number],
            default: '0',
        },
        total: {
            type: String,
            default: '0'
        },
        isTotal: {
            type: Boolean,
            default: false
        },
        thirtyDays: {
            type: String,
            default: '< 30 days',
        },
        error: {
            type: Boolean,
            default: false,
        }
    },
    emits: ['click'],
    computed: {
        thirtyDaysExpired() {
            if (this.title.includes('Expiring') && +this.counter > 0) {
                return true
            }
            return false
        },
        unRedirectable() {
            if (this.isLoading || +this.counter === 0 || !this.allowed) {
                return true
            }
            return false
        }
    }
}
</script>

<style lang="scss" scoped>
.audience_usage {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px 18px;
  width: 100%;
  min-height: 104.5px;
  cursor: pointer;

  &.audience_usage:hover {
    box-shadow: 0px 3px 3px 1px rgba(0, 0, 0, 0.1);
  }

  &.unredirectable {
    pointer-events: none;
    cursor: default;
  }
  
  .has_an_error {
    display: flex;
    margin-left: 0;
  }
  
  &.thirty_days_expired {
    background-color: rgba(245, 158, 11, .1);

    border: 1px solid #f59e0b;
    .thirty-days {
      color: #f59e0b;
      font-size: 14px;
      font-weight: normal;
    }

    .audience_usage-content {
      font-size: 15px;
      color: #FC6D55;
      .nb_active_audience {
        font-size: 25px;
        font-weight: bold;
      }
    }
  }

  .audience_usage-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }

  .audience_usage-title {
    font-size: 14px;
    color: #374151;
  }

  .audience_usage-content {
    font-size: 15px;
    color: #111827;
    .nb_active_audience {
      font-size: 25px;
      font-weight: bold;
    }
  }
}
</style>
